import React, { useRef, useEffect, useState } from 'react';
import Wrapper from './styles';
import ErrorIcon from '../../../assets/img/error.svg';
import SuccessIcon from '../../../assets/img/check.svg';
import TimerIcon from '../../../assets/img/icnTime.svg';

const IngresoClaveSMS = ({
  length,
  status,
  onFinished,
  durationInSeconds,
  errorMessage,
  successMessage,
  helperText,
  onRetry,
  maxLengthPerInput,
  casoBordeIntentosFallidos
}) => {
  const inputsRef = useRef([]);

  const [seconds, setSeconds] = useState(durationInSeconds > 60 ? durationInSeconds % 60 : 0);
  const [minutes, setMinutes] = useState(
    durationInSeconds < 60 ? 0 : Math.floor(durationInSeconds / 60)
  );
  const [timerOn, setTimerOn] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [finished, setFinished] = useState(false);
  const [auxConcat, setAuxConcat] = useState([]);
  const [backspace, setBackspace] = useState(false);

  useEffect(() => {
    setTimerOn(true);
    inputsRef.current[0].focus();
    setDisabled(casoBordeIntentosFallidos);
    setFinished(casoBordeIntentosFallidos);
  }, []);

  useEffect(() => {
    let interval = null;
    if (timerOn) {
      interval = setInterval(() => {
        if (seconds === 0) {
          setSeconds(59);
          setMinutes((prevMinutes) => prevMinutes - 1);
        } else {
          setSeconds((prevSeconds) => prevSeconds - 1);
        }
      }, 1000);
      if (seconds === 0 && minutes === 0) {
        setTimerOn(false);
        setDisabled(true);
      }
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timerOn, seconds, minutes]);

  const handleRetry = () => {
    setSeconds(durationInSeconds > 60 ? durationInSeconds % 60 : 0);
    setMinutes(durationInSeconds < 60 ? 0 : Math.floor(durationInSeconds / 60));
    setTimerOn(true);
    setDisabled(false);
    setFinished(false);
    for (let input of inputsRef.current) {
      input.value = '';
    }
    inputsRef.current[0].focus();
    onRetry();
  };

  const handleKeyUp = (e, index) => {
    const { value } = e.target;
    if (e.key === 'Backspace' && index > 0 && inputsRef.current[index].value === '') {
      inputsRef.current[index - 1].focus();
      setBackspace(true);
      return;
    }
    if (isNaN(value) || (e.key === 'Backspace' && index === 0)) {
      inputsRef.current[index].value = '';
      return;
    }
    setBackspace(false);
    if (index < length - 1) {
      if ((backspace && index > 0) || (inputsRef.current[index].value !== value)) {
        inputsRef.current[index + 1].value = value;
      }
      inputsRef.current[index + 1].focus();
    } else {
      const concat = inputsRef.current
        .reduce((acc, input) => acc + input.value.toString(), 0)
        .substring(1);
      onFinished(concat);
      setAuxConcat(concat.split(''));
      setDisabled(true);
      setFinished(true);
    }
  };

  return (
    <Wrapper retry={(!finished && !timerOn) || (finished && !status)} casoBordeIntentosFallidos={casoBordeIntentosFallidos}>
      <div className="input-container">
        <div className="input-grid">
          {!finished
            ? [...Array(length)].map((value, index) => (
                <div className="input-column" key={index}>
                  <input
                    ref={(element) => (inputsRef.current[index] = element)}
                    type="text"
                    disabled={disabled}
                    maxLength={maxLengthPerInput}
                    className={`input-SMS-${index}`}
                    onKeyUp={(e) => handleKeyUp(e, index)}
                  />
                </div>
              ))
            : [...Array(length)].map((value, index) => (
                <div className="input-column" key={index}>
                  <input
                    ref={(element) => (inputsRef.current[index] = element)}
                    type="text"
                    disabled={disabled}
                    maxLength={maxLengthPerInput}
                    className={`input-SMS-${index}`}
                    value={auxConcat[index]}
                  />
                </div>
              ))}
        </div>
        <span>
          {finished && !status && (
            <span className="error-message">
              <img className="img-error" src={ErrorIcon} alt="Error" />
              <span className="retry-message">
                {errorMessage}
                <span className="retry" disabled={casoBordeIntentosFallidos} onClick={() => handleRetry()}>
                  Reintentar
                </span>
              </span>
            </span>
          )}
          {finished && status && (
            <span className="success-message">
              <img className="img-success" src={SuccessIcon} alt="Success" />
              {successMessage}
            </span>
          )}
          {!finished && (
            <div className="timer-message">
              <img className="img-timer" src={TimerIcon} alt="Timer" />
              <strong className="timer">
                {`${minutes < 10 ? `0${minutes}` : minutes}:${
                  seconds < 10 ? `0${seconds}` : seconds
                }`}
              </strong>
              {helperText}
              {!timerOn && (
                <span className="retry-message">
                  <span className="retry" disabled={casoBordeIntentosFallidos} onClick={() => handleRetry()}>
                    Reintentar
                  </span>
                </span>
              )}
            </div>
          )}
        </span>
      </div>
    </Wrapper>
  );
};

export default IngresoClaveSMS;
